import { createClient } from "tinacms/dist/client";
import { queries } from "./types";
export const client = createClient({ cacheDir: '/Users/davidshore/.codex/release-artifacts/homepage-admin-release-20261023/candidate/packages/frontend/tina/__generated__/.cache/1792764523469', url: 'http://localhost:4407/graphql', token: '58c5718e91bc9058b417d0ae4c11b44644a5c75c', queries,  });
export default client;
  